module.exports = __webpack_public_path__ + "static/media/cloud.2f0ef38e.png";